import { API_CACHE_NAME } from "@/constants";

/**
 * Clear the Service Worker API cache.
 * This is useful when switching user context (e.g., impersonation)
 * to ensure fresh data is fetched.
 */
export async function clearServiceWorkerCache(): Promise<void> {
  if ("caches" in window) {
    try {
      await caches.delete(API_CACHE_NAME);
    } catch (error) {
      console.error("[SW Cache] Error clearing cache:", error);
    }
  }
}
